export default __webpack_public_path__ + "static/media/IF_MyLeadershipStrengths_StrengthArea_01.f1105c61.jpg";